import i18next from "i18next";
import React from "react";
import { I18nextProvider, initReactI18next } from "react-i18next";

import chat from "translations/en/chat.json";
import coachmarkENUS from "translations/en/coachmark.json";
import commonENUS from "translations/en/common.json";
import constantsENUS from "translations/en/constants.json";
import faqsENUS from "translations/en/faqs.json";
import guestPreview from "translations/en/guest-preview.json";
import landingpage from "translations/en/landingpage.json";
import navigation from "translations/en/navigation.json";
import space from "translations/en/space.json";
import timestampENUS from "translations/en/timestamp.json";
import toolbarENUS from "translations/en/toolbar.json";
import tutorialENUS from "translations/en/tutorial.json";
import user from "translations/en/user.json";
import validationENUS from "translations/en/validation.json";
import commonFR from "translations/fr/common.json";

/*
 * DESCRIPTION
 * Wraps component with i18next provider component
 *
 * EXTERNAL DEPENDENCIES
 * - React i18next
 *   https://www.npmjs.com/package/react-i18next
 */

i18next.use(initReactI18next).init({
  interpolation: { escapeValue: false }, // React already does escaping
  lng: "en",
  fallbackLng: "en",
  resources: {
    en: {
      validation: validationENUS,
      common: commonENUS,
      timestamp: timestampENUS,
      constants: constantsENUS,
      coachmark: coachmarkENUS,
      faqs: faqsENUS,
      tutorial: tutorialENUS,
      landingpage,
      toolbar: toolbarENUS,
      guestPreview,
      space,
      navigation,
      chat,
      user,
    },
    fr: {
      common: commonFR,
    },
  },
});

export const withI18NProvider = Component => {
  return props => {
    return (
      <I18nextProvider i18n={i18next}>
        <Component {...props} />
      </I18nextProvider>
    );
  };
};

export default i18next;
